import inviteAdvisor from './inviteAdvisor'

const KIND_PERSON_JURIDIC = 'juridic'
const KIND_PERSON_PERSONAL = 'personal'

const KIND_RESPONSIBLE = 'responsible'
const KIND_SUBSTITUTE = 'substitute'

const PERSON_TYPE_OPTIONS = [
  { id: KIND_PERSON_PERSONAL, name: 'Pessoa Física' },
  { id: KIND_PERSON_JURIDIC, name: 'Pessoa Jurídica' },
]

const DPO_TYPE_OPTIONS = [
  { id: KIND_RESPONSIBLE, name: 'Encarregado' },
  { id: KIND_SUBSTITUTE, name: 'Substituto' },
]

const DEFAULT_DPO_VALUES = {
  name: '',
  email: '',
  document: '',
  kindPerson: KIND_PERSON_PERSONAL,
  kind: inviteAdvisor.DPO_TYPE.RESPONSIBLE,
}

const fantasyDpo = {
  DEFAULT_DPO_VALUES,
  DPO_TYPE_OPTIONS,
  KIND_PERSON_JURIDIC,
  KIND_PERSON_PERSONAL,
  KIND_RESPONSIBLE,
  KIND_SUBSTITUTE,
  PERSON_TYPE_OPTIONS,
}

export default fantasyDpo
